module.exports = __webpack_public_path__ + "media/images/matching-3-846a66382a1787e3175ca6af2c055d6e.jpg";